import EcocolordopplerAortaAddominaleEdit from "./components/EcocolordopplerAortaAddominaleEdit.vue";
import EcocolordopplerAortaAddominaleView from "./components/EcocolordopplerAortaAddominaleView.vue";
import EcocolordopplerAortaAddominaleList from "./components/EcocolordopplerAortaAddominaleList.vue";

export default {
    EcocolordopplerAortaAddominaleEdit,
    EcocolordopplerAortaAddominaleView,
    EcocolordopplerAortaAddominaleList,
};
